import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persistedstate';
import { DocaiderEmbed } from "docaider-embed/vue";

const app = createApp(App);

// Configure Pinia with persistence
const pinia = createPinia();
pinia.use(piniaPersist);

// Register all plugins
app.use(DocaiderEmbed);
app.use(router);
app.use(pinia);

// Mount the app
app.mount("#app");